import React from 'react';

import { Row } from '@/components/lib/components';

import { EventMatchupText } from '../EventMatchupText';
import { EventTimeInfo } from '../EventTimeInfo';

type ParlayMatchupHeaderProps = {
    eventId: string;
};

export const ParlayMatchupHeader = ({ eventId }: ParlayMatchupHeaderProps) => {
    return (
        <Row>
            <EventMatchupText eventId={eventId} color="neutral300" />
            <EventTimeInfo eventId={eventId} color="neutral300" />
        </Row>
    );
};
